<template>
  <v-container class="admin-corporateVendor" fluid>
    <v-row class="flex-grow-0">
      <v-col>
        <label class="text-h5">{{ $t('admin_hkiarace.corporate_vendor') }}</label>
      </v-col>
      <v-col class="text-right">
        <v-btn color="primary"
               @click="addCorporateVendorModalShown = true">
          {{ $t('admin_corporate_vendor.add_title') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row class="flex-grow-1">
      <v-col class="pa-0">
        <CorporateVendorList full-height
                       :refresh-trigger.sync="refreshTrigger"
                       @edit="onCorporateVendorEdit"></CorporateVendorList>
      </v-col>
    </v-row>

    <AddCorporateVendorModal :shown="addCorporateVendorModalShown"
                       @cancel="addCorporateVendorModalShown = false"
                       @finish="onAddCorporateVendorModalFinish"></AddCorporateVendorModal>

    <EditCorporateVendorModal :shown="editCorporateVendorModalShown"
                        :corporate-vendor-id="editingCorporateVendorId"
                        @cancel="onEditCorporateVendorModalFinish"
                        @finish="onEditCorporateVendorModalFinish"></EditCorporateVendorModal>
  </v-container>
</template>

<script>
import {ref} from "@vue/composition-api";
import CorporateVendorList from "@/components/corporateVendor/CorporateVendorList";
import AddCorporateVendorModal from "@/components/corporateVendor/AddCorporateVendorModal";
import EditCorporateVendorModal from "@/components/corporateVendor/EditCorporateVendorModal";

export default {
  name: 'CorporateVendor',
  components: {EditCorporateVendorModal, AddCorporateVendorModal, CorporateVendorList},
  setup(props, {root}) {
    const refreshTrigger = ref(false);
    const refresh = function () {
      refreshTrigger.value = !refreshTrigger.value;
    };

    const addCorporateVendorModalShown = ref(false);
    const onAddCorporateVendorModalFinish = function (item) {
      addCorporateVendorModalShown.value = false;
      refresh();
      onCorporateVendorEdit(item);
    }

    const editingCorporateVendorId = ref(null);
    const editCorporateVendorModalShown = ref(false);
    const onCorporateVendorEdit = function (item) {
      editingCorporateVendorId.value = item.id;
      editCorporateVendorModalShown.value = true;
    };
    const onEditCorporateVendorModalFinish = function () {
      editCorporateVendorModalShown.value = false;
      refresh();
    }

    return {
      refreshTrigger,
      refresh,

      addCorporateVendorModalShown,
      onAddCorporateVendorModalFinish,

      editingCorporateVendorId,
      editCorporateVendorModalShown,
      onCorporateVendorEdit,
      onEditCorporateVendorModalFinish,
    }
  }
}
</script>

<style lang="less">
.admin-corporateVendor {
  height: 100%;
  display: flex;
  flex-direction: column;
}
</style>
